import supportMessageActions from './supportMessage/actions';
import optionActions from './option/actions';

const modalActions = {
    ...supportMessageActions,
    ...optionActions
};

export default modalActions;
